(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.tjoriHeroReady) return;
    const slides = [...root.querySelectorAll('.tjori-hero__slide')];
    if (slides.length < 2) return;
    root.dataset.tjoriHeroReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const dots = [...root.querySelectorAll('[data-tjori-dot]')];
    const delay = Math.max(2500, Number(root.dataset.autoplay) || 5500);
    const autoplay = root.dataset.autoplayOn !== 'false';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, target = 0, timer, preloadTimer, startX = 0, hovered = false, inView = true;
    function prepare(i) {
      const slide = slides[i];
      const template = slide.querySelector('template');
      if (template) {
        const content = template.content.cloneNode(true);
        const image = content.querySelector('img');
        if (image) { image.loading = 'eager'; image.fetchPriority = 'low'; }
        template.replaceWith(content);
      }
      const image = slide.querySelector('img');
      return image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
    }
    function stop() { clearTimeout(timer); clearTimeout(preloadTimer); }
    function restart() {
      stop();
      if (reduce.matches || !autoplay || hovered || !inView || document.hidden) return;
      preloadTimer = setTimeout(() => prepare((index + 1) % slides.length), Math.max(0,delay - 2500));
      timer = setTimeout(() => go(index + 1), delay);
    }
    async function go(nextIndex) {
      stop();
      const next = (nextIndex + slides.length) % slides.length;
      target = next;
      await prepare(next);
      if (target !== next || signal.aborted) return;
      slides[index].classList.remove('is-active');
      dots[index]?.classList.remove('is-active');
      dots[index]?.setAttribute('aria-current','false');
      index = next;
      slides[index].classList.add('is-active');
      dots[index]?.classList.add('is-active');
      dots[index]?.setAttribute('aria-current','true');
      restart();
    }
    for (const dot of dots) dot.addEventListener('click',() => go(Number(dot.dataset.tjoriDot)),{signal});
    root.querySelector('[data-tjori-prev]')?.addEventListener('click',() => go(target - 1),{signal});
    root.querySelector('[data-tjori-next]')?.addEventListener('click',() => go(target + 1),{signal});
    root.addEventListener('touchstart',event => {startX=event.changedTouches[0].clientX;},{passive:true,signal});
    root.addEventListener('touchend',event => {
      const dx = event.changedTouches[0].clientX-startX;
      if(Math.abs(dx)>=40) go(target+(dx<0?1:-1));
    },{passive:true,signal});
    root.addEventListener('mouseenter',() => {hovered=true;stop();},{signal});
    root.addEventListener('mouseleave',() => {hovered=false;restart();},{signal});
    document.addEventListener('visibilitychange',restart,{signal});
    const observer = new IntersectionObserver(entries => {inView=entries[0].isIntersecting;restart();});
    observer.observe(root);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload',() => {
      stop(); controller.abort(); observer.disconnect(); delete root.dataset.tjoriHeroReady;
    },{once:true,signal});
    root.closest('.shopify-section')?.addEventListener('shopify:block:select',event => {
      const selected=slides.findIndex(slide=>slide===event.target||slide.contains(event.target));
      if(selected>=0) go(selected);
    },{signal});
    restart();
  }
  const init = scope => scope.querySelectorAll('[data-tjori-hero]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjori-featured-product"] && !Shopify.designMode) return;
  try {
    
function renderMoney(element, markup) {
      if (!element) return;
      const fragment = document.createElement('template');
      fragment.innerHTML = markup;
      if (!fragment.content.querySelector('span.money')) {
        const span = document.createElement('span');
        span.className = 'money';
        span.append(fragment.content);
        element.replaceChildren(span);
      } else {
        element.replaceChildren(fragment.content);
      }
    }

    function refreshCurrency() {
      if (window.bucksCC?.getConfig?.()?.active && typeof window.bucksCC.reConvert === 'function') {
        window.bucksCC.reConvert();
      } else if (window.baCurr?.config?.enabled && typeof window.baCurr.refreshConversion === 'function') {
        window.baCurr.refreshConversion();
      }
    }

class TjoriFeaturedProduct extends HTMLElement {
  connectedCallback() {
    if (this.controller || !this.querySelector('[data-tfp-product]')) return;
    this.controller = new AbortController();
    this.product = JSON.parse(this.querySelector('[data-tfp-product]').textContent);
    this.money = JSON.parse(this.querySelector('[data-tfp-money]').textContent);
    this.input = this.querySelector('[data-tfp-variant-id]');
    this.input.name = 'id';
    this.selected = this.product.options.map((_, index) => {
      const selected = this.querySelector('[data-tfp-option-index="' + index + '"] .is-selected');
      const initial = this.product.variants.find(variant => String(variant.id) === this.input.value);
      return selected?.dataset.tfpOptionValue ?? initial?.options[index];
    });
    this.busy = false;
    this.addEventListener('click', event => this.selectOption(event), {signal:this.controller.signal});
    this.querySelector('[data-tfp-form]').addEventListener('submit', event => this.submit(event), {signal:this.controller.signal});
    refreshCurrency();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  currentVariant() {
    return this.product.variants.find(variant => variant.options.every((value, index) => value === this.selected[index]));
  }

  selectOption(event) {
    const button = event.target.closest('[data-tfp-option-value]');
    if (!button || !this.contains(button) || this.busy) return;
    const fieldset = button.closest('[data-tfp-option-index]');
    this.selected[Number(fieldset.dataset.tfpOptionIndex)] = button.dataset.tfpOptionValue;
    for (const choice of fieldset.querySelectorAll('[data-tfp-option-value]')) {
      const active = choice === button;
      choice.classList.toggle('is-selected', active);
      choice.setAttribute('aria-pressed', String(active));
    }
    this.querySelector('[data-tfp-status]').textContent = '';
    this.update(true);
  }

  update(updatePrices) {
    const variant = this.currentVariant();
    this.input.value = variant?.id ?? '';
    this.input.disabled = !variant;
    const available = !!variant?.available;
    const onSale = !!variant && variant.compare_at_price > variant.price;
    const stock = this.querySelector('[data-tfp-stock]');
    if (stock) {
      stock.textContent = !variant ? this.dataset.unavailable : available ? this.dataset.available : this.dataset.soldOut;
      stock.classList.toggle('is-out', !available);
    }
    for (const button of this.querySelectorAll('[data-tfp-action]')) button.disabled = this.busy || !available;
    this.querySelector('[data-tfp-add-label]').textContent = !variant ? this.dataset.unavailable : available ? this.dataset.addLabel : this.dataset.soldOut;
    if (!updatePrices) return;
    const compare = this.querySelector('[data-tfp-compare]');
    const badge = this.querySelector('[data-tfp-badge]');
    compare.hidden = !onSale;
    if (badge) badge.hidden = !onSale;
    if (variant) {
      renderMoney(this.querySelector('[data-tfp-price]'), this.money[variant.id].price);
      if (onSale) renderMoney(compare, this.money[variant.id].compare);
      else compare.replaceChildren();
      refreshCurrency();
      const image = this.querySelector('img.tjori-featured__image');
      if (image && this.dataset.customImage !== 'true' && variant.featured_image?.src) {
        const source = new URL(variant.featured_image.src, location.origin);
        image.srcset = [320,400,480,600,800,1000,1200].map(width => {
          source.searchParams.set('width',width);
          return source.href + ' ' + width + 'w';
        }).join(', ');
        source.searchParams.set('width','1200');
        image.src = source.href;
      }
    } else {
      this.querySelector('[data-tfp-price]').textContent = this.dataset.unavailable;
      compare.replaceChildren();
    }
  }

  async submit(event) {
    event.preventDefault();
    const status = this.querySelector('[data-tfp-status]');
    if (window.Shopify?.designMode) { status.textContent = this.dataset.preview; return; }
    const variant = this.currentVariant();
    if (this.busy || !variant?.available) return;
    this.busy = true;
    this.update(false);
    status.textContent = '';
    try {
      const addUrl = new URL(event.currentTarget.action);
      addUrl.pathname = addUrl.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(addUrl, {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
      });
      if (!response.ok) throw new Error(this.dataset.error);
      if (!this.isConnected) return;
      if (event.submitter?.dataset.tfpAction === 'buy') {
        const base = this.dataset.rootUrl.replace(/\/$/, '');
        window.location.assign(base + '/checkout');
      } else {
        status.textContent = this.dataset.added;
        if (typeof window.tjoriCartOpen === 'function') window.tjoriCartOpen();
        else window.location.assign(this.dataset.cartUrl);
      }
    } catch (error) {
      if (this.isConnected) status.textContent = this.dataset.error;
    } finally {
      this.busy = false;
      if (this.isConnected) this.update(false);
    }
  }
}

if (!customElements.get('tjori-featured-product')) customElements.define('tjori-featured-product', TjoriFeaturedProduct);


  } catch(e) { console.error(e); }
})();
})();
